import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="http://vmedianadvertising.com/" target="_blank">
            V Media & Advertising
          </a>{" "}
          2026
        </p>
      </div>
    </div>
  );
};

export default Footer;
